import { ILanguagesResponse } from "../../api/get/getLanguages";

const mapContentLanguageValue = (
  language: string,
  languages: ILanguagesResponse[]
) => {
  switch (language.toLowerCase()) {
    case "en":
      return languages.find(({ id }) => id === 4)?.language ?? "English";

    case "es":
      return languages.find(({ id }) => id === 19)?.language ?? "English";

    case "ko":
      return languages.find(({ id }) => id === 14)?.language ?? "English";

    case "ja":
      return languages.find(({ id }) => id === 13)?.language ?? "English";

    case "zh-cn":
      return languages.find(({ id }) => id === 2)?.language ?? "English";

    case "zh-cht":
      return languages.find(({ id }) => id === 3)?.language ?? "English";

    case "vi":
      return languages.find(({ id }) => id === 20)?.language ?? "English";

    case "id":
      return languages.find(({ id }) => id === 11)?.language ?? "English";

    case "th":
      return languages.find(({ id }) => id === 24)?.language ?? "English";

    default:
      return "English";
  }
};

export default mapContentLanguageValue;
